import styled from 'styled-components';
import photo1 from 'assets/images/photo-1.jpg';
import photo2 from 'assets/images/photo-2.jpg';
import photo3 from 'assets/images/photo-3.jpg';
import photo4 from 'assets/images/photo-4.jpg';
import photo5 from 'assets/images/photo-5.jpg';
import { fonts } from 'styles';

export const Container = styled.main`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding-bottom: 96px;
`;

export const Wrapper = styled.section`
  width: 100%;
  max-width: max-content;
  display: flex;
  column-gap: 48px;
  margin: 0 auto;
  padding: 65px 0;

  @media screen and (max-width: 960px) {
    padding: 32px 0;
    flex-direction: column;

    &.right {
      flex-direction: column-reverse;
    }
  }
`;

export const Content = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.left {
    align-items: flex-end;
  }

  &.right {
    align-items: flex-start;
  }

  &.text {
    width: auto;
  }

  @media screen and (max-width: 960px) {
    width: 100%;

    &.left {
      align-items: center;
    }

    &.right {
      align-items: center;
    }
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 498px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 26px;
  color: #fff;

  &.right {
    text-align: right;
    h2 {
      text-align: right;
    }
  }

  p {
    margin-bottom: 40px;

    a {
      color: #fff;
      text-decoration: underline;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 960px) {
    max-width: 100%;
    padding: 48px 32px 0 32px;
    &.right {
      text-align: left;
      h2 {
        text-align: left;
      }
    }
  }
`;

export const Title = styled.h2`
  font-family: ${fonts.BentonSansCondensedBold};
  font-size: 32px;
  line-height: 26px;
  color: #fff;
  text-transform: uppercase;
  margin-bottom: 40px;

  @media screen and (max-width: 500px) {
    font-size: 28px;
    line-height: 26px;
  }
`;

export const Legend = styled.div`
  width: 100%;
  max-width: 680px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 13px;
  line-height: 20px;
  color: #dedede;
  margin-top: 24px;

  @media screen and (max-width: 960px) {
    max-width: 100%;
    padding: 0 32px;
  }
`;

export const Photo1 = styled.img.attrs({ src: photo1 })`
  object-fit: contain;
  height: max-content;

  @media screen and (max-width: 960px) {
    width: 100%;
    height: auto;
  }
`;

export const Photo2 = styled.img.attrs({ src: photo2 })`
  object-fit: contain;
  height: max-content;

  @media screen and (max-width: 960px) {
    width: 100%;
    height: auto;
  }
`;
export const Photo3 = styled.img.attrs({ src: photo3 })`
  object-fit: contain;
  height: max-content;

  @media screen and (max-width: 960px) {
    width: 100%;
    height: auto;
  }
`;
export const Photo4 = styled.img.attrs({ src: photo4 })`
  object-fit: contain;
  height: max-content;

  @media screen and (max-width: 960px) {
    width: 100%;
    height: auto;
  }
`;
export const Photo5 = styled.img.attrs({ src: photo5 })`
  object-fit: contain;
  height: max-content;

  @media screen and (max-width: 960px) {
    width: 100%;
    height: auto;
  }
`;

export const Credits = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 26px;
  color: #dedede;
  width: 100%;
  max-width: 1229px;
  margin: 0 auto;
  padding-top: 18px;

  @media screen and (max-width: 960px) {
    padding: 32px;
  }
`;
